import React from "react";
import Project from "./index";

export function ProjectInProgress() {
  return <Project status="En cours" />;
}